import { FC } from 'react';
import {
  CalendarOutlined,
  HeartOutlined,
  TagOutlined
} from '@ant-design/icons';
import { Space, Typography, Image } from 'antd';

import { StyledIcon } from './styled';
import { IInfoItemProps } from './types';

const { Text, Title } = Typography;

const icons = {
  tag: <TagOutlined style={{ color: 'var(--white)', fontSize: 20 }} />,
  calendar: (
    <CalendarOutlined style={{ color: 'var(--white)', fontSize: 20 }} />
  ),
  heart: <HeartOutlined style={{ color: 'var(--white)', fontSize: 20 }} />
};

const InfoItem: FC<IInfoItemProps> = ({ title, subtitle, icon, uri }) => {
  return (
    <Space size={12}>
      {uri ? (
        <Image
          src={uri}
          width={44}
          height={44}
          preview={false}
          style={{ objectFit: 'cover', borderRadius: '50%' }}
        />
      ) : (
        <StyledIcon>{icon && icons[icon]}</StyledIcon>
      )}

      <div>
        <Text style={{ color: '#6B7083' }}>{title}</Text>
        <Title style={{ margin: 0 }} level={5}>
          {subtitle}
        </Title>
      </div>
    </Space>
  );
};

export default InfoItem;
